$(document).ready(function() {
    $('.single-item').slick({
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 2000,
    });
    $('.swiper-slider-type-1').slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        responsive: [
            {
            breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('.swiper-slider-type-2').slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 6,
        slidesToScroll: 6,
        infinite: false,
        responsive: [
            {
            breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: true,
                    dots: true
                }
            },
            {
            breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });

    $('.swiper-slider-type-3').slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 8,
        slidesToScroll: 8,
        infinite: false,
        responsive: [
            {
            breakpoint: 1280,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                    infinite: true,
                    dots: true
                }
            },
            {
            breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    infinite: true,
                    dots: true
                }
            },
            {
            breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });

    
    function hidePoweredBy() { 
      $('.subify-powered-text').css('display','none');
      if (!$('.separator').length) { 
        $(".h_buttons").after('<div class="css-9c3fff-methodDivider separator"><span class="MuiTypography-root MuiTypography-body1 css-1fuofhp">or</span></div>');
      }

      window.history.replaceState({}, '', window.location.origin + window.location.pathname + window.location.search);
    }
    setTimeout(hidePoweredBy, 100);
    setTimeout(hidePoweredBy, 500);
    setTimeout(hidePoweredBy, 1000);
    setTimeout(hidePoweredBy, 2000);
    setTimeout(hidePoweredBy, 3000);
    setTimeout(hidePoweredBy, 4000);
    setTimeout(hidePoweredBy, 5000);


    function reloadLoginPage(){
      if ($('#customer_login').css('display') === 'block') {
        window.location.reload();
      }
    }
    setTimeout(hidePoweredBy, 5000);

    //Timeline
    var inputs = $('.input');
    var paras = $('.description-flex-container').find('p');
    inputs.click(function(){
      var t = $(this),
          ind = t.index(),
          matchedPara = paras.eq(ind);
      
      t.add(matchedPara).addClass('active');
      inputs.not(t).add(paras.not(matchedPara)).removeClass('active');
    });
    
    let $inputs = $('.input');
    let current = 0;
    let isAutoClick = false;

    let autoClick = setInterval(function() {
      $inputs.removeClass('active');
      $inputs.eq(current).addClass('active');

      // mark as auto-click so handler knows not to stop the interval
      isAutoClick = true;
      $inputs.eq(current).trigger('click');

      // reset the flag on the next tick so a fast user click after trigger is treated as manual
      setTimeout(function() {
        isAutoClick = false;
      }, 0);

      current = (current + 1) % $inputs.length;
    }, 3000);

    // Only clear interval when the click is manual (not an auto-click)
    $inputs.on('click', function() {
      if (!isAutoClick) {
        clearInterval(autoClick);
      }
    });

    
    $('.profile-tab').on('click', function () {
       $('button[data-tab="profile"]').trigger('click');
    });

    $('.bp-item').on('click', function () {
      var tab = $(this).data('tab');

      // Active tab button
      $('.bp-item').removeClass('bp-active');
      $(this).addClass('bp-active');

      // Show panel
      $('.bp-panel').addClass('bp-hidden');
      var panel = $('[data-panel="' + tab + '"]');
      if (panel.length) {
        panel.removeClass('bp-hidden');
      }

      // Close button click
      $('.bp-close').trigger('click');

      // Update URL section param without reload
      var url = new URL(window.location.href);
      url.searchParams.set('section', tab);
      console.log(url);console.log(window.location);
      window.history.replaceState({}, '', url);
      window.history.replaceState({}, '', window.location.pathname + window.location.search);

    });


    
});


//default tab based on URL
document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  const section = urlParams.get('section');
  const tabButtons = document.querySelectorAll('.bp-item[data-tab]');

  let defaultBtn = tabButtons[0];
  if (section) {
    const targetBtn = document.querySelector(`[data-tab="${section}"]`);
    if (targetBtn) defaultBtn = targetBtn;
  }
  if(defaultBtn){
    defaultBtn.click();
  } 
});

document.addEventListener('DOMContentLoaded', function() {
  const headers = document.querySelectorAll('.order-header');
  headers.forEach(header => {
    header.addEventListener('click', function() {
      const orderId = this.getAttribute('data-order-id');
      const details = document.getElementById('details-' + orderId);
      const icon = this.querySelector('.toggle-icon');
      
      if (details.style.display === 'none') {
        details.style.display = 'table-row';
        icon.textContent = '-';
      } else {
        details.style.display = 'none';
        icon.textContent = '+';
      }
    });
  });
});

//open/close sidebar in mobile
document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('.bp-root');
  const toggle = document.querySelector('.bp-toggle');
  const closeBtn = document.querySelector('.bp-close');

  // open
  if (toggle) {
    toggle.addEventListener('click', () => {
      root.classList.toggle('bp-sidebar-open');
    });
  }

  // close button inside sidebar
  if(closeBtn){
    closeBtn.addEventListener('click', () => {
      root.classList.remove('bp-sidebar-open');
    });
  }
  

  // optional backdrop close
  document.addEventListener('click', e => {
    if (root.classList.contains('bp-sidebar-open') && e.target === root) {
      root.classList.remove('bp-sidebar-open');
    }
  });
});



//Addresses save
$(document).ready(function() { 
    // prepare Options Object 
    var options1 = {
        beforeSubmit: function(arr, $form, options) { 
          $.blockUI();
        },
        success:    function() { 
          $('.address-form.addresses__edit-form').addClass('hidden');
          alert("Address Updated successfully!");
          $.unblockUI();
          $('html, body').animate({ scrollTop: 0 }, 'slow');
        } 
    }; 
    var options2 = {
        beforeSubmit: function(arr, $form, options) { 
          $.blockUI();
        },
        success:    function() { 
          $.unblockUI();
          alert("Address added successfully!");
          window.location.reload(true);
        } 
    }; 
    $('.edit-customer-address').ajaxForm(options1);
    $('#address_form_new').ajaxForm(options2); 

    //custlo
    $("#bp-profile-form").on("submit", function(e){
      e.preventDefault();
      $.blockUI();
      accepts_marketing = "unsubscribed";
      if ($('#profile-accepts_marketing').is(':checked')) {
        accepts_marketing = "subscribed";
      }
      // JSON data
      const data = {
        "id": $("#profile-customer-id").val(),
        "first_name": $("#profile-first-name").val(),
        "last_name": $("#profile-last-name").val(),
        "email": $("#profile-email").val(),
        "date_of_birth": {
          "value": $("#date_of_birth").val(),
          "defination_namespace": "custom"
        },
        "phone": {
          "value": $("#profile-mobile").val(),
          "defination_namespace": "custom"
        },
        "accepts_marketing": accepts_marketing,
        "target": "profile-data"
      };

      // AJAX POST request
      $.ajax({
        url: "/apps/customerdashboard",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        success: function(response){
          //console.log("Profile updated:", response);
          $.unblockUI();
          alert("Profile updated successfully!");
          window.location.reload(true);
        },
        error: function(xhr, status, error){
          $.unblockUI();
          alert("Profile updated successfully!");
          console.error("Error:", xhr.responseText || error);
          alert("Failed to update profile. Please try again.");
        }
      });
    });
}); 







// assets/blood-portal.js
/*(function(){
  const root = document.getElementById('blood-portal');
  if(!root) return;
  const config = JSON.parse(document.getElementById('bp-config').textContent || '{}');

  // helpers
  const qs = (sel, ctx=document)=> ctx.querySelector(sel);
  const qsa = (sel, ctx=document)=> Array.from(ctx.querySelectorAll(sel));

  // Tabs
  qsa('.bp-item').forEach(btn => btn.addEventListener('click', ev => {
    const tab = btn.getAttribute('data-tab');
    qsa('.bp-item').forEach(b=>b.classList.remove('bp-active'));
    btn.classList.add('bp-active');
    qsa('.bp-panel').forEach(p=> p.classList.add('bp-hidden'));
    const panel = qs('[data-panel="'+tab+'"]');
    if(panel) panel.classList.remove('bp-hidden');
    document.querySelector('.bp-close').click();

    const url = new URL(window.location);
    url.searchParams.set('section', tab);
    console.log(url);
    window.history.replaceState({}, '', url); // updates without reload
    //window.history.replaceState({}, '', window.location.pathname + window.location.search);
  }));

  // Booking subnav
  //qsa('.bp-sub-item').forEach(s => s.addEventListener('click', ()=>{ qsa('.bp-sub-item').forEach(x=>x.classList.remove('bp-sub-active')); s.classList.add('bp-sub-active'); }));

  // Profile form logic:
  const profileForm = qs('#bp-profile-form');
  if(profileForm){
    // Hook into the form submit: let Shopify /account handle updating core customer properties.
    profileForm.addEventListener('submit', function(e){
      // let normal submit proceed (non-AJAX) so the storefront updates customer properties.
      // But also capture extended fields like dob and send to App Proxy.
      // We don't prevent default here so user will be redirected back to account page on success.
    });

    // Save extended data (dob) via App Proxy when user clicks 'Save extended...'
    const extBtn = qs('#bp-save-extended');
    if(extBtn){
      extBtn.addEventListener('click', async function(){
        const dob = qs('#dob').value;
        // App proxy endpoint: /apps/bp-proxy (must be provided by a Shopify app)
        try{
          const res = await fetch('/apps/blood-portal/customer_metafield', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ dob })
          });
          if(res.ok){
            const span = qs('.bp-saved-msg'); span.style.display='inline-block'; setTimeout(()=>span.style.display='none',2000);
          } else {
            const json = await res.text();
            alert('Failed to save extended data: '+ json);
          }
        } catch(err){
          alert('Failed to reach App Proxy. Ensure a Shopify App proxy is configured at /apps/bp-proxy.');
        }
      });
    }
  }

  // Booking demo logic (client-side)
  const calendarEl = qs('#bp-calendar');
  const slotsEl = qs('#bp-slots');
  const payBtn = qs('#bp-pay');
  const amountInput = qs('#bp-amount');
  const calendarWrapper = qs('.bp-calendar-wrapper');
  const confirmBtn = qs('#bp-confirm');
  const upcomingEl = qs('#bp-upcoming');

  function makeDays(count=35){
    const days=[]; const now = new Date();
    for(let i=0;i<count;i++){ const d=new Date(now); d.setDate(now.getDate()+i); days.push(d);} return days;
  }

  let selectedDate = null; let selectedSlot = null; let paid=false;

  function renderCalendar(){
    calendarEl.innerHTML='';
    const days = makeDays(35);
    days.forEach(d=>{
      const btn = document.createElement('button'); btn.textContent = d.getDate();
      btn.addEventListener('click', ()=>{
        selectedDate = d; qsa('#bp-calendar button').forEach(x=>x.classList.remove('selected')); btn.classList.add('selected'); renderSlots(); updateConfirm();
      });
      if(selectedDate && selectedDate.toDateString()===d.toDateString()) btn.classList.add('selected');
      calendarEl.appendChild(btn);
    });
  }

  function renderSlots(){
    slotsEl.innerHTML=''; (config.slots||[]).forEach(s=>{
      const b = document.createElement('button'); b.className='bp-slot'; b.textContent = s;
      b.addEventListener('click', ()=>{ selectedSlot=s; qsa('.bp-slot').forEach(x=>x.classList.remove('selected')); b.classList.add('selected'); updateConfirm(); });
      if(selectedSlot===s) b.classList.add('selected'); slotsEl.appendChild(b);
    });
  }

  function updateConfirm(){ confirmBtn.disabled = !(paid && selectedDate && selectedSlot); }

  

  

  // initial render
  //renderCalendar(); renderSlots(); updateConfirm();
  const existing = localStorage.getItem('bp_booking');
  if(existing){ const p=JSON.parse(existing); upcomingEl.textContent = `Booked: ${new Date(p.date).toDateString()} • ${p.slot} • $${p.amount}`; }

})();*/

/* Chub app
$("#save-profile").on("click", function(e){
  e.preventDefault();

  // build JSON data
  const data = {
    shop: "iv4b1f-jp.myshopify.com",
    customerId: "8970429333733",
    hash: "611ff7a7ee38aae622ea95a9eb01226b",
    namespace: "custom",
    first_name: "developers2",
    last_name: "test2",
    email: "developersunittest@gmail.com",
    phone: {
      dial_code: "1",
      value: "9123456789"
    },
    metafield: {
      date_of_birth: {
        date: "2000-02-10"
      }
    }
  };

  // AJAX POST
  $.ajax({
    url: "/a/customerhub/account/update-profile-ae",
    method: "POST",
    contentType: "application/json",
    data: JSON.stringify(data),
    success: function(response){
      console.log("Profile updated:", response);
      alert("Profile saved successfully!");
    },
    error: function(xhr){
      console.error("Error saving profile:", xhr.responseText);
      alert("Error updating profile!");
    }
  });
});*/